var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5938 6H21M4 6L5.0625 20.9375M4 6H6M4 6H2.5M11.5 6L12.0625 7.5L12.25 8M11.5 6H10M11.5 6H21M17.5 22L16.75 20M12.25 8L13 10M12.25 8H17.5M13 10H23.25M13 10L13.75 12M13.75 12H23.5M13.75 12L14.5 14M14.5 14H23M14.5 14L15.25 16M15.25 16L16 18M15.25 16H19.5M16 18H21.5938M16 18L16.75 20M16.75 20H20.1875M10 6L14.5 23.1875M10 6H8M8 6L11 23.3438M8 6H6M6 6L7 16.5M2.5 6V6C2.36887 6 2.32465 5.82487 2.44005 5.76261L6.58092 3.52872C6.68976 3.47 6.8165 3.4537 6.93665 3.48297L8.91239 3.96424C9.08306 4.00581 9.26303 3.95477 9.38647 3.82979L11.2351 1.95801C11.4645 1.72583 11.8511 1.77199 12.0193 2.05162L13 3.68182M2.5 6V18.4375M13.75 4.50001L13 3.68182M13 3.68182L15.0928 2.27397C15.3189 2.12185 15.6252 2.17883 15.7815 2.4021L17.0767 4.2525C17.1833 4.40469 17.3654 4.48527 17.5497 4.46175L18.5195 4.33794C18.6474 4.32162 18.7766 4.35529 18.8802 4.43194L21 6M19.5 8H22.5M21 16H22.6875M7.5 19L8 22.6563",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/Field.3b35bbf3af787b25ee7fc495d0457e6a.svg";
export { ForwardRef as ReactComponent };